import { render, staticRenderFns } from "./investorList.vue?vue&type=template&id=f98120fc&scoped=true&"
import script from "./investorList.vue?vue&type=script&lang=js&"
export * from "./investorList.vue?vue&type=script&lang=js&"
import style0 from "./investorList.vue?vue&type=style&index=0&id=f98120fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98120fc",
  null
  
)

export default component.exports